import { useState, useEffect } from "react";
import "./Header.css";
import { FaEnvelope, FaPhone } from "react-icons/fa";

const adSlides = [
  "Free worldwide shipping on orders above €50",
  "Flat 25% off on all vitamins & supplements",
  "100% genuine medicines, GMP-certified",
  "24/7 customer support — always here for you",
];

function Header() {
  const [activeAd, setActiveAd] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveAd((prev) => (prev + 1) % adSlides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="header-bottom">

      <a className="header-contact-link" href="mailto:support@realgenericshop.com">
        <span className="header-icon-chip">
          <FaEnvelope />
        </span>
        <span className="header-contact-text">support@realgenericshop.com</span>
      </a>

      <div className="header-marquee">
        {adSlides.map((text, index) => (
          <span
            key={index}
            className={`header-marquee-slide ${index === activeAd ? "active" : ""}`}
          >
            {text}
          </span>
        ))}
      </div>

      <a className="header-contact-link" href="tel:+919876543210">
        <span className="header-icon-chip">
          <FaPhone style={{ transform: "scaleX(-1)" }} />
        </span>
        <span className="header-contact-text">+91 98765 43210</span>
      </a>

    </div>
  );
}

export default Header;